import React from 'react';
import { CheckCircle, Circle, HelpCircle, XCircle } from 'lucide-react';
import { REVIEW_STATUS } from '../../../constants';

const Summary = (props) => {
  const { answerStatuses } = props;

  const counts = {
    [REVIEW_STATUS.CORRECT]: 0,
    [REVIEW_STATUS.PARTIAL]: 0,
    [REVIEW_STATUS.INCORRECT]: 0,
    [REVIEW_STATUS.SKIPPED]: 0
  };

  answerStatuses.forEach(({ status }) => {
    if (counts[status] !== undefined) {
      counts[status]++;
    }
  });

  const statusCards = [
    {
      key: REVIEW_STATUS.CORRECT,
      count: counts[REVIEW_STATUS.CORRECT],
      label: 'Correct',
      icon: CheckCircle,
      containerClass: 'bg-green-50 border-green-100',
      iconClass: 'text-green-600',
      countClass: 'text-green-700',
      labelClass: 'text-green-600'
    },
    {
      key: REVIEW_STATUS.PARTIAL,
      count: counts[REVIEW_STATUS.PARTIAL],
      label: 'Partial',
      icon: HelpCircle,
      containerClass: 'bg-amber-50 border-amber-100',
      iconClass: 'text-amber-600',
      countClass: 'text-amber-700',
      labelClass: 'text-amber-600'
    },
    {
      key: REVIEW_STATUS.INCORRECT,
      count: counts[REVIEW_STATUS.INCORRECT],
      label: 'Incorrect',
      icon: XCircle,
      containerClass: 'bg-red-50 border-red-100',
      iconClass: 'text-red-500',
      countClass: 'text-red-700',
      labelClass: 'text-red-600'
    },
    {
      key: REVIEW_STATUS.SKIPPED,
      count: counts[REVIEW_STATUS.SKIPPED],
      label: 'Skipped',
      icon: Circle,
      containerClass: 'bg-yellow-50 border-yellow-100',
      iconClass: 'text-yellow-600',
      countClass: 'text-yellow-700',
      labelClass: 'text-yellow-600'
    }
  ];

  return (
    <div className="mb-5 grid grid-cols-2 gap-2">
      {statusCards.map(
        ({ key, count, label, icon: Icon, containerClass, iconClass, countClass, labelClass }) => (
          <div
            key={key}
            className={`flex items-center gap-2 rounded-lg border px-3 py-2 ${containerClass}`}
          >
            <Icon className={`h-4 w-4 flex-shrink-0 ${iconClass}`} />
            <div>
              <p className={`text-sm font-semibold ${countClass}`}>{count}</p>
              <p className={`text-xs ${labelClass}`}>{label}</p>
            </div>
          </div>
        )
      )}
    </div>
  );
};

export { Summary };
